// Keep definitions in sync with terraform/eng-alerts/mod/base/main.tf
export enum Priority {
  /**
   * An important system is unavailable.
   */
  P1 = "P1",
  /**
   * An important system is severely degraded.
   */
  P2 = "P2",
  /**
   * A system has a possible issue.
   */
  P3 = "P3",
  /**
   * A system has an unimportant issue.
   */
  P4 = "P4",
  /**
   * Informational issue.
   */
  P5 = "P5",
}
